<template>
  <div class="full-page">
    <div data-v-4cdc70d3="" style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; background-color: rgba(0, 0, 0, 0.0);"></div>

    <div style="position:absolute;left:0;right:0;top:0px">
      <div class="container inner-page" style="background:none">
        <div style="position:relative">
          <img style="display:inline-block; max-width: 300px;margin-top: 50px; " src="../assets/logo.png" />

          <div class="btn btn-text lg-switch-btn" @click="changeLG">{{ $t('home.languageSwitch') }}</div>
        </div>
      </div>
    </div>

    <div class="hero-panel container" style="z-index: 10;">
      <div>
        <div class="hero-title" v-html="$t('home.title')"></div>
        <div class="hero-subtitle" v-html="$t('home.subTitle')"></div>
        <div class="hero-buttons">
          <div class="btn hero-btn" style="margin: 0; margin-right:5px; padding: 10px 20px !important; font-size:20px !important" @click="start">
            <span>{{ $t('home.btnText') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

export default {
  name: 'Home',

  components: {
    /* Swiper,
    SwiperSlide, */
  },

  props: {},

  directives: {
    // swiper: directive,
  },

  data() {
    return {
      swiperOptions: {
        effect: 'fade',
        loop: true,
        speed: 300,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },

        pagination: {},
        // Some Swiper option/callback...
      },
    };
  },

  computed: {},

  methods: {
    async start() {
      if (this.$store.isMobile) {
        this.continue();
        return;
      }

      const { domain } = this.$i18n.messages;
      const fullLink = `https://${domain}`;

      // todo no qrcode cache for special qr (auth)
      const qrCodeLink = `/api/qr?fullLink=${encodeURIComponent(fullLink)}&qrSize=240&qrMargin=2&bgColor=${encodeURIComponent('#000')}`;

      // eslint-disable-next-line max-len
      const warningSvg =
        '<svg width="61" height="54" viewBox="0 0 61 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M59.9042 48.1255L33.6803 2.72785C32.2307 0.224059 28.6068 0.224059 27.1573 2.72785L0.933365 48.1255C-0.516198 50.6293 1.26281 53.792 4.16194 53.792H56.6097C59.5747 53.792 61.3538 50.6293 59.9042 48.1255ZM29.5952 16.6305C31.1765 16.2351 32.7578 17.0258 33.4826 18.4754C33.7462 19.0025 33.8121 19.5955 33.7462 20.1226C33.6144 21.7698 33.5485 23.4171 33.4826 25.1302C33.3508 27.6999 33.1532 30.3354 33.0214 32.9051C32.9555 33.6958 32.9555 34.4864 32.8896 35.343C32.8237 36.7267 31.7695 37.7809 30.3858 37.7809C29.0681 37.7809 27.9479 36.7267 27.882 35.4089C27.6844 31.3896 27.4208 27.3704 27.2232 23.3512C27.1573 22.2969 27.0914 21.1768 27.0255 20.1226C27.0255 18.5413 28.0797 17.0258 29.5952 16.6305ZM30.4517 46.8077C28.6068 46.8077 27.1573 45.2923 27.1573 43.4474C27.1573 41.6025 28.6727 40.087 30.5176 40.087C32.3625 40.087 33.8121 41.6025 33.8121 43.5133C33.7462 45.2923 32.2307 46.8077 30.4517 46.8077Z" fill="#F19F28"/></svg>';

      const result = await this.$swal({
        html:
          "<div style='padding-top:28px'>" +
          // eslint-disable-next-line max-len
          `<div style='text-align: left;display: inline-flex;justify-content: left;'><div style='padding-right: 16px;padding-top: 6px;'>${warningSvg}</div><div>${this.$i18n.t(
            'home.phoneSwitch',
          )}</div></div>` +
          `<div style='margin-top:22px'><img src="${qrCodeLink}" style="width: 240px; z-index: 1;" /></div>` +
          '</div>',
        showConfirmButton: false,
        cancelButtonText: this.$i18n.t('home.desktopContinue'),
        showCancelButton: true,
        showCloseButton: true,

        customClass: {
          cancelButton: 'cancel-alert-desktop',
        },
      });

      if (result.dismiss && result.dismiss === 'cancel') {
        this.continue();
      }
    },

    continue() {
      console.log('Push theme');
      this.$router.push({ name: 'Themes' });
    },

    changeLG(e) {
      e.preventDefault();
      e.stopPropagation();

      const lg = this.$i18n.t('home.languageSwitchLocale');
      console.log('Switch language', lg);
      // eslint-disable-next-line no-undef
      this.$i18n.locale = lg;
    },
  },

  mounted() {},
};
</script>

<style scoped></style>
